import React, {useState} from 'react';
import InnerSelect, {Creatable,AsyncCreatable} from 'react-select';
import {withStyles} from '@material-ui/core/styles';
import components from './components';
import styles from './styles';
import i18n from "../../../i18n";

const CreatableSelect = ({classes, theme, fullWidth, label, name, multiple, error, touched, ...props}) => {


    const selectStyles = {
        input: base => ({
            ...base,
            color: theme.palette.text.primary,
            '& input': {
                font: 'inherit',
            },
        }),

    };

    const [isLoading,setIsLoading] = useState(false);
    const [options,setOptions] = useState(props.options);

    return (
        <Creatable
            id={name}
            name={name}
            classes={classes}
            styles={selectStyles}
            components={components}
            noOptionsMessage={() => i18n.get('default.select.noOptions')}
            textFieldProps={{
                label,
                fullWidth,
                error: touched && !!error,
                helperText: touched && error,
                InputLabelProps: {
                    shrink: true,
                },
            }}
            isMulti={multiple}
            placeholder={label}
            formatCreateLabel={input => {
                let object = props.newOptionLabel || 'Option';
                return i18n.get(
                    'default.select.create_option',
                    {object: object,option: input}
                )
            }}
            isDisabled={isLoading}
            isLoading={isLoading}
            onCreateOption={(option) => {
                //setIsLoading(true);
                //setIsLoading(false);
                props.onCreated(option);
            }}
            {...props}
        />
    );
};

CreatableSelect.defaultProps = {
    fullWidth: true,
};


export default withStyles(styles, {withTheme: true})(CreatableSelect);
